<template>
    <footer id="footer" :class="[$mq, {TA:isTestAchat}]">
        <hr :class="$mq">
        <div class="box">
            <div>
                <h2 class="txt-left mega-title">&copy; Mega {{ date }}</h2>
                <p class="small-text txt-left" v-html="$t('Footer.brand')"></p>
            </div>

          <div>
            <ul class="box-links">
              <li>
                <a class="link" target="_blank" :href="$t('Footer.cookiesUrl')">{{ $t('Footer.cookies') }}</a>
              </li>
              <li class="separator">|</li>
              <li>
                <a class="link" target="_blank" :href="$t('Footer.privacyUrl')">{{ $t('Footer.privacy') }}</a>
              </li>
              <li class="separator">|</li>
              <li>
                <a class="link" target="_blank" :href="$t('Footer.disclaimerUrl')">{{ $t('Footer.disclaimer') }}</a>
              </li>
            </ul>
            <img src="@/assets/logoFooterGrey.svg" alt="Logo Mega" class="logo" />
          </div>

        </div>
        
    </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
      ...mapGetters("subscription", ["isTestAchat"]),
        date() {
            return new Date().getFullYear();
        }
    }
}
</script>


<style lang="scss" scoped>
footer {
    z-index: 0;
    padding: 40px 0 20px 0;
    display: flex;
    flex-flow: column;
    width: 80%;
    margin: auto;
    flex-shrink: 0;

    hr {
        width: 100%;
        border: none;
        border-top: 1px solid $middleGrey;

        &.mobile {
        display: none;
        }
    }
    
    .box {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center !important;

        &.mobile{
            flex-flow: column;
        }

        .mega-title {
            margin-bottom: 0px;
            font-size: 14px;
        }

        .small-text {
            font-size: 12px;
            margin-top: 0px;
        }
    }

     .logo {
        width: 120px;
    }

    &.mobile {
        padding-top: 30px;
    }

  .link {
    text-decoration: underline;
    color: inherit;
    margin-top: -10px;
    padding: 0 5px 5px 5px;
    font-size: 12px;

    @media screen and (max-width: 800px) {
      text-decoration-color: #FFFFFF;
      text-decoration-thickness: 1px;
    }
  }

  .separator {
    padding: 0 5px;
    color: #231f20;

    @media screen and (max-width: 800px) {
      display: none;
    }

  }

  .box-links {
    display: flex;
    flex-direction: row;
    list-style-type: none;
    @media screen and (max-width: 800px) {
      flex-direction: column;
      text-align: right;
      width: 175px;
    }
  }
}

.TA {
  .link {
    color: $pink
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue